import { render } from "./ProductSelectionProductsProductDetail.vue?vue&type=template&id=261c5618&scoped=true&ts=true"
import script from "./ProductSelectionProductsProductDetail.vue?vue&type=script&lang=ts"
export * from "./ProductSelectionProductsProductDetail.vue?vue&type=script&lang=ts"

import "./ProductSelectionProductsProductDetail.vue?vue&type=style&index=0&id=261c5618&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-261c5618"]])

export default __exports__